import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { environment } from '@env/environment';
import { filter } from 'rxjs';
import { BottomNavComponent } from '@components/bottom-nav/bottom-nav.component';
import { HeaderComponent } from '@components/header/header.component';
import { MenuScreenComponent } from '@components/menu/menu.component';
import { ShareDetailsComponent } from '@components/share-details/share-details.component';
import { ApiService } from '@core/service/api.service';
import { AuthService } from '@core/service/auth.service';

@Component({
  selector: 'app-full-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HeaderComponent, BottomNavComponent, MenuScreenComponent],
  templateUrl: './full-layout.component.html',
  styleUrls: ['./full-layout.component.scss']
})
export class FullLayoutComponent {
  readonly mockMode = environment.mockMode;
  showBottomNav = true;
  showHeader = true;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private bottomSheet: MatBottomSheet,
    private apiService: ApiService,
    private authService: AuthService,
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        let currentRoute = this.route.firstChild;
        while (currentRoute?.firstChild) {
          currentRoute = currentRoute.firstChild;
        }
        this.showBottomNav = currentRoute?.snapshot.data['showBottomNav'] !== false;
        this.showHeader = currentRoute?.snapshot.data['showHeader'] !== false;
      });

      if (this.authService.isAuthenticated()) {
        this.me();
      }
  }

  openShareDetailBottomsheet() {
    this.bottomSheet.open(ShareDetailsComponent, {
      panelClass: ['share-details-bottomsheet', 'common-bottomsheet'],
      backdropClass: 'bottomsheet-modal-backdrop'
    });
  }

  me() {
    this.apiService.apiCall('get', '/ownly/auth/me').subscribe({
      next: (response) => { },
      error: (error) => {
        this.apiService.showMessageModal(error.error?.message, false);
        if (error.error?.statusCode == 401) {
          this.authService.logout();
          this.router.navigate(['/login-clerk'])
        }
      }
    })
  }
}
